import { useCheckoutErrors } from "lib/hooks/useCheckoutErrors";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { classNames, isEmptyObj } from "lib/utils/helpers";
import { WarningCircle, Warning } from "@phosphor-icons/react";
import { useUserContext } from "lib/contexts/UserProvider";

const OrderSummaryErrorHeader = () => {
  const {
    state: { checkoutLoading },
  } = useCheckoutContext();
  const {
    state: { user },
  } = useUserContext();

  const { errorMessage, isAddItemsWorthDelivery, isWeightBasedShipping, isItemNotServicable } =
    useCheckoutErrors();
  if (
    !errorMessage ||
    checkoutLoading ||
    isEmptyObj(user) ||
    !(isWeightBasedShipping || isAddItemsWorthDelivery || isItemNotServicable)
  ) {
    return null;
  }
  return (
    <div className="relative z-10 px-3 py-2 text-ouch">
      <Warning className="h-4 w-4 text-ouch" />
    </div>
  );
};

const OrderSummaryErrorCustom = ({
  customErrorMessage,
  rounded = "center",
}: {
  customErrorMessage?: string;
  rounded?: "bottom" | "center";
}) => {
  const {
    state: { checkoutLoading },
  } = useCheckoutContext();
  const {
    state: { user },
  } = useUserContext();
  const { errorMessage } = useCheckoutErrors();
  if ((!customErrorMessage && !errorMessage) || checkoutLoading || isEmptyObj(user)) {
    return null;
  }
  return (
    <div className="relative text-xs text-coal-dark overflow-hidden w-full">
      <div
        className={classNames(
          "absolute w-full h-full bg-ouch opacity-10",
          rounded === "bottom" ? "rounded-b-lg" : "rounded-lg",
        )}></div>
      <div className="flex items-center">
        <WarningCircle className="ml-2 text-ouch" size={16} />
        <div className="relative px-2 py-2 text-ouch text-left">
          {customErrorMessage ?? errorMessage}
        </div>
      </div>
    </div>
  );
};

export { OrderSummaryErrorHeader, OrderSummaryErrorCustom };
